<template>
    <Loading>
        <div
            class="location-skeleton-root d-flex align-items-center flex-row px-1 pt-2"
        >
            <div
                class="location-skeleton-item w-100 px-2"
                v-for="i in 4"
                :key="i"
            >
                <Row class="image-row w-100 mb-3" />
                <Row />
            </div>
        </div>
    </Loading>
</template>

<script>
import Loading from '~/components/skeletons/base/Loading';
import Row from '~/components/skeletons/base/Row';

export default {
    name: 'LocationSkeleton',
    components: { Loading, Row },
};
</script>

<style scoped>
.image-row {
    height: 80px;
}

.location-skeleton-root {
    display: flex;
    flex-direction: row;
}

@media only screen and (max-width: 600px) {
    .location-skeleton-root {
        overflow: hidden;
    }

    .location-skeleton-item {
        width: 100vw;
    }
}
</style>
